import { useDispatch } from 'react-redux';

import type { QuestionConfigQuestionType } from '/index';
import type { QuestionTreeItem } from '/business/shared/functions/types';
import { QUESTION_BRANCH_ACTIVITY, QUESTION_BRANCH_CUSTOM, QUESTION_BRANCH_SUPPLIER } from '/shared/util/Statics';
import type { AppDispatch } from '/business/shared/state/store';
import { showModal } from '/shared/state/actions/modal';

import StyledEducationWidget from '/business/shared/components/widgets/education/_styled/StyledEducationWidget';

import modalIcon from '/business/shared/images/icons/bp-question-circled-interface-white.svg';

const allowedValues = [QUESTION_BRANCH_CUSTOM, QUESTION_BRANCH_SUPPLIER, QUESTION_BRANCH_ACTIVITY] as const;
type AllowedValue = (typeof allowedValues)[number];
type EducationQuestionTreeItem = QuestionTreeItem & {
  education?: QuestionConfigQuestionType['education'];
};
type EducationQuestion = QuestionConfigQuestionType | EducationQuestionTreeItem;

function EducationWidget({
  question,
  branchType,
  displayCustom = true,
  displaySupplier = true,
}: {
  question: EducationQuestion;
  branchType?: AllowedValue;
  displaySupplier?: boolean;
  displayCustom?: boolean;
}) {
  const dispatch = useDispatch<AppDispatch>();
  if (!question || question?.type === 'group' || !question?.education?.hasEducationWidget) {
    return null;
  }
  const getTitle = (baseQuestion: EducationQuestion): string | undefined => {
    if (baseQuestion.type === 'subQuestion') {
      if (!baseQuestion.parent) {
        return undefined;
      }
      return getTitle(baseQuestion.parent);
    }
    if (baseQuestion.type === 'question' || !baseQuestion.type) {
      return baseQuestion.title;
    }
  };
  const questionTitle = getTitle(question);

  const handleModal = () => {
    dispatch(
      showModal({
        name: 'EDUCATION',
        metadata: {
          title: questionTitle,
          branchType: branchType,
          contents: question?.education?.educationContent,
          bottomContentsAll: question?.education?.bottomContentsAll,
          bottomContentsActivity: question?.education?.bottomContentsActivity,
          bottomContentsSupplier: question?.education?.bottomContentsSupplier,
          bottomContentsCustom: question?.education?.bottomContentsCustom,
          hasNoBottomSection: question?.education?.hasNoBottomSection,
          onlyUseCustomRender: question?.education?.onlyUseCustomRender || false,
          displayCustom: displayCustom,
          displaySupplier: displaySupplier,
        },
      }),
    );
  };

  return (
    <StyledEducationWidget onClick={handleModal}>
      {/* <img src={helpImg} alt="help button" /> */}
      <div onClick={handleModal}>
        <img src={modalIcon} alt="question mark" />
        <p>Help</p>
      </div>
    </StyledEducationWidget>
  );
}

export default EducationWidget;
